import types from './Types/index';
import dynamic from './Dynamic/index';

const composers = types.concat(dynamic);

export default composers;
